import CountUp from "react-countup";
import {
  Container,
  ContainerPrimary,
  TotalValue,
  HeaderImg,
  ContainerSecunday,
  Title,
  Icon,
  BackButton,
} from "./style";
import {useValue} from "../../../providers/ValueContext"
import { useHistory } from "react-router-dom";

const HeaderReport = ({ title, pathImg }) => {

  const { entranceValueMarket } = useValue()
  const history = useHistory()

  return (
    <Container>
      <ContainerPrimary>
        <TotalValue>
          <HeaderImg src="./images/cifrao_white.svg" />
          <CountUp
            end={entranceValueMarket}
            separator="."
            decimal=","
            decimals={2}
            duration={0.5}
          />
        </TotalValue>
      </ContainerPrimary>
      <ContainerSecunday>
        <Icon src={pathImg} />
        <Title>{title}</Title>
        <BackButton onClick={() => history.push("/mapMaketplace")} />
      </ContainerSecunday>
    </Container>
  );
};
export default HeaderReport;
